import { NavigateFunction } from "react-router-dom";
import { ROUTE_PATHS } from "../../../../routes/paths";
import { AmbassadorSignupFormData } from "./config";
import { AmbassadorSignupResponseData } from "./types";

export async function handleAmbassadorSignupSuccess(
  userData: AmbassadorSignupResponseData,
  navigate: NavigateFunction,
  fetchUserProfile: () => Promise<any>
): Promise<void> {
  if (userData.profileId) {
    await fetchUserProfile();
    navigate(ROUTE_PATHS.MY_PROFILE);
  } else {
    navigate(ROUTE_PATHS.AUTH.SIGNUP_MORE_ABOUT_AMBASSADOR_COMPANY);
  }
}

export function getAmbassadorSignupPayload(
  data: AmbassadorSignupFormData
): {
  email: string;
  firstName: string;
  lastName: string;
  password: string;
  role: string;
} {
  return {
    email: data.email.toLowerCase(),
    firstName: data.firstName,
    lastName: data.lastName,
    password: data.password,
    role: "ambassador",
  };
}
